<template>
  <footer class="footer">
    <div class="footer-section">
      <div class="wrapper">
        <div class="left">
          <router-link to="/" class="logo">
            <img src="./../images/logo.webp" class="img" />
          </router-link>
          <div class="desc" v-if="settings">
            © {{ new Date().getFullYear() }} {{ settings.copyright }}
          </div>
          <div class="desc" v-if="settings">{{ settings.requisites }}</div>
        </div>
        <div class="right">
          <div class="navs">
            <ul class="nav">
              <template v-for="item in $parent.socialLinks">
                <li class="nav__item" :key="item.id">
                  <a target="_blank" class="desc" :href="item.link">
                    {{ $t(item.title) }}
                  </a>
                </li>
              </template>
            </ul>
            <ul class="nav">
              <template v-for="item in $parent.nav">
                <li class="nav__item" :key="item.id">
                  <router-link class="desc" :to="item.path">
                    {{ $t(item.title) }}
                  </router-link>
                </li>
              </template>
            </ul>
            <ul class="nav">
              <template v-for="item in textPageList">
                <li class="nav__item" :key="item.id">
                  <a class="desc" @click="goToPage(item)">
                    {{ $t(item.title) }}
                  </a>
                </li>
              </template>
            </ul>
          </div>
          <a :href="'mailto:' + settings.support_email" class="desc link">{{
            settings.support_email
          }}</a>
          <div class="methods">
            <img src="./../images/methods/1.svg" class="img" />
            <img src="./../images/methods/2.svg" class="img" />
            <img src="./../images/methods/3.svg" class="img" />
            <img src="./../images/apple-f-pay.svg" class="img appley-pay" />
            <img src="./../images/google-f-pay.svg" class="img google-pay" />
            <!-- <img src="./../images/methods/4.svg" class="img" />
            <img src="./../images/methods/5.svg" class="img" />
            <img src="./../images/methods/6.svg" class="img" /> -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: ["settings"],
  data: function () {
    return {
      textPageList: [],
    };
  },
  methods: {
    getTextPages() {
      this.$http
        .get(process.env.VUE_APP_API + "static-pages")
        .then((res) => {
          this.textPageList = res.data.payload;
        })
        .catch(() => {});
    },
    goToPage(item) {
      this.$router.push({
        path: "/pages/" + item.id,
        params: { data: item.id },
      });
      this.$emit("getTextPageContent", item.id);
    },
  },
  mounted() {
    this.getTextPages();
  },
};
</script>
